module.exports = __webpack_public_path__ + "img/location.809a07f4.svg";